import React from "react";
import Chevva from "../assets/chevva.svg";
import Mail from "../assets/mail.svg";
import Phone from "../assets/phone.svg";
import Location from "../assets/location.svg";
import Instagram from "../assets/instagram.svg";
import Facebook from "../assets/facebook.svg";
import Linkedin from "../assets/linkedin.svg";
import "../styles/PersonalDetails.css";

export default function PersonalDetails() {
  return (
    <div className="personal-details">
      <div className="personal-details-image">
        <img src={Chevva} alt="Chevva" />
      </div>
      <div className="personal-details-name">
        <h1>Vamshi Chevva</h1>

        <p>Product Designer</p>
      </div>

      <div className="personal-details-bottomsection">
        <div className="personal-details-email">
          <div className="personal-details-icon">
            <img src={Mail} alt="Mail" />
          </div>
          <div className="personal-details-email-text">
            <p>Email:</p>
            <a href="mailto:contact@chevvavamshi.com">
              contact@chevvavamshi.com
            </a>
          </div>
        </div>

        <div className="personal-details-phone">
          <div className="personal-details-icon">
            <img src={Phone} alt="Phone" />
          </div>
          <div className="personal-details-phone-text">
            <p>Phone:</p>
            <a href="callto:+447442388571">+447442388571</a>
          </div>
        </div>

        <div className="personal-details-location">
          <div className="personal-details-icon">
            <img src={Location} alt="Location" />
          </div>
          <div className="personal-details-location-text">
            <p>Location:</p>
            <p>
              8 Broadgate, <br />
              Preston, PR18DX
            </p>
          </div>
        </div>
      </div>

      <div className="social-links">
        <div className="personal-details-email-icon">
          <a
            href="https://uk.linkedin.com/in/vamshi-chevva-8b773a2b3"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={Instagram} alt="Instagram" />
          </a>
        </div>
        <div className="personal-details-email-icon">
          <a
            href="https://uk.linkedin.com/in/vamshi-chevva-8b773a2b3"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={Facebook} alt="Facebook" />
          </a>
        </div>
        <div className="personal-details-email-icon">
          <a
            href="https://uk.linkedin.com/in/vamshi-chevva-8b773a2b3"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={Linkedin} alt="Linkedin" />
          </a>
        </div>
      </div>
    </div>
  );
}
